import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { actions } from '../../reducers';
import constants from '../../constants';

const { PREVIOUS } = constants.pages;

export default compose(
  connect(null, {
    goToPage: actions.pages.goToPage,
    goToPreviousPage: actions.pages.goToPreviousPage
  }),
  withProps(props => ({
    goToPage: () => {
      props.page === PREVIOUS
        ? props.goToPreviousPage()
        : props.goToPage(props.page);
    }
  }))
);



// WEBPACK FOOTER //
// ./src/components/link-icon/enhance.js